<template>
  <form action="" class="gwf gateway-form">
    <error :errors="errors"></error>

    <div class="form-block">
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="form-group">
            <label class="form-group__label form-group__label--required" for="">{{
              $t("gateways.legal_entity")
            }}</label>
            <b-form-select required :options="entities" />
          </div>
        </div>

        <div class="crate-legal-entity col-12">
          <p>
            {{ $t("gateways.create_entity_text") }}
          </p>
          <button type="button" class="bttn bttn--sm bttn--orange" name="button">
            {{ $t("gateways.create_entity_button") }}
          </button>
        </div>

        <div class="col-12">
          <div class="row align-items-end">
            <div class="col-12">
              <h3>
                {{ $t("gateways.seller_info") }}
              </h3>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_first_name")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_last_name")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_birthdate")
                }}</label>
                <b-form-input required type="date" />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_gender")
                }}</label>
                <b-form-select required>
                  <option value="m">{{ $t("gateways.seller_gender_m") }}</option>
                  <option value="w">{{ $t("gateways.seller_gender_w") }}</option>
                </b-form-select>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_address_country")
                }}</label>

                <b-form-select required> </b-form-select>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_address_city")
                }}</label>
                <b-form-input required type="text"> </b-form-input>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_address_street")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_address_street_number")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_description")
                }}</label>
                <b-form-input required />
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_email")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_phone")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_social_id")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_social_id_issued")
                }}</label>
                <b-form-input required type="date" />
              </div>
            </div>

            <div class="col-12">
              <h3>{{ $t("gateways.bank_info") }}</h3>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.bank_account_currency")
                }}</label>
                <b-form-select required></b-form-select>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_bank_account_number")
                }}</label>
                <b-form-input required />
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_bank_branch")
                }}</label>
                <b-form-input required type="number" />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_bank_code")
                }}</label>
                <b-form-select required type="number" />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_inc_code")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_merchant_name")
                }}</label>
                <b-form-input required />
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label for="">{{ $t("gateways.max_payments") }}</label>
                <b-form-select />
              </div>
            </div>
            <!-- wait back-end -->
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label for="">{{ $t("gateways.installments") }}</label>
                <b-form-select />
              </div>
            </div>
            <!-- wait back-end -->

            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_file_cheque")
                }}</label>
                <label
                  for="seller_file_cheque"
                  :class="cheque_invalid ? 'file-upload-input invalid' : 'file-upload-input'"
                  >{{ $t("gateways.import_file") }}<br />{{
                }}</label>
                <input type="file" id="seller_file_cheque" />
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_file_corporate")
                }}</label>
                <label
                  for="seller_file_corporate"
                  :class="corporate_invalid ? 'file-upload-input invalid' : 'file-upload-input'"
                  >{{ $t("gateways.import_file") }}<br />{{
                }}</label>
                <input type="file" id="seller_file_corporate" />
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label class="form-group__label form-group__label--required" for="">{{
                  $t("gateways.seller_file_social_id")
                }}</label>
                <label
                  for="seller_file_social_id"
                  :class="
                    social_id_invalid
                      ? 'file-upload-input invalid'
                      : 'file-upload-input upload-file'
                  "
                  >{{ $t("gateways.import_file") }}<br />{{
                }}</label>
                <input type="file" id="seller_file_social_id" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="gateway-form__action">
      <button type="button" :class="entities.length > 0 ? 'bttn bttn--lg bttn--blue' : 'bttn bttn--lg bttn--blue el-right'" name="button">{{ $t('gateways.close') }}</button>
      <button type="submit"  v-if='entities.length > 0' :class="sending ? 'disabled bttn bttn--lg bttn--orange' : 'bttn bttn--lg bttn--orange'">{{ $t('gateways.save') }}</button>
    </div> -->
  </form>
</template>

<script>
import { mapState } from "vuex";

import error from "@/components/errors.vue";

export default {
  props: ["entities", "editdata"],

  data() {
    return {
      payMeData: {
        data: {
          attributes: {},
        },
      },
      statusType: [
        { value: false, text: "Disabled" },
        { value: true, text: "Enabled" },
      ],
      errors: [],
      sending: false,
    };
  },

  components: {
    error: error,
  },

  computed: mapState({}),

  methods: {},
};
</script>

<style lang="scss" scoped>
.crate-legal-entity {
  button {
    display: block;
    margin: 20px auto;
  }
}

.alert-danger {
  width: auto;
  margin-left: 0;
  li {
    width: auto;
    margin-left: 0;
  }
}

.gwf.gateway-form .form-block label {
  max-width: 100%;
}

input[type="file"] {
  display: none;
}
</style>
